import React from 'react';
import { Link } from 'react-router-dom';

import { useToast } from 'Component/Alerta';
import Botao from 'Component/Botao';
import Funcao from 'Interface/Funcoes';
import { useEditarFuncaoMutation } from 'View/Service/Default/Funcoes';

interface Props {
    dados: Funcao;
    acoes?: boolean;
}

const Lista = ({dados, acoes = true}: Props): React.ReactElement =>
{
    const toast = useToast();
    const [ editarFuncao ] = useEditarFuncaoMutation();

    const remover = async (): Promise<void> =>
    {
        try {
            await editarFuncao({ id: dados.id, ativo: 0 }).unwrap();

            toast({
                conteudo: 'Removido com sucesso!',
                tema: 'success',
            });
        } catch (erro) {
            toast({
                titulo: 'Erro ao remover',
                conteudo: 'Verifique o registro de log para mais detalhes!',
                tema: 'danger',
            });
        }
    }

    return (
        <div
            key={dados.nome}
            className="d-flex border-bottom align-items-center py-2 px-3"
        >
            <div className="fs-4">
                <Link to={`/funcoes/editar/${dados.id}`} className="text-decoration-none">
                    {dados.nome}
                </Link>
            </div>
            <div className="ms-5 fs-5 flex-grow-1 text-end">
                {acoes && (
                    <Botao
                        icone="trash"
                        tema="danger"
                        className="ms-5"
                        confirmacao="Você tem certeza que deseja remover essa função? Essa ação é irreversivel."
                        onClick={ remover }
                    />
                )}
            </div>
        </div>
    )
}

export default Lista;
